import { useCallback, useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useServiceWorkerUpdateStore } from '@store/ServiceWorkerUpdateStore';

const intervalMS = 60 * 5 * 1000; // 5 minutes
let updateInterval: ReturnType<typeof setInterval> | undefined;

export const ServiceWorkerUpdateRegistration = () => {
  const setNeedRefresh = useServiceWorkerUpdateStore((state) => state.setNeedRefresh);
  const setUpdateServiceWorker = useServiceWorkerUpdateStore((state) => state.setUpdateServiceWorker);

  const {
    needRefresh: [needRefresh, setRegistrationNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration?: ServiceWorkerRegistration) {
      if (updateInterval) {
        clearInterval(updateInterval);
      }

      if (!registration) return;

      updateInterval = setInterval(() => {
        void registration.update();
      }, intervalMS);
    },
    onRegisterError(error: unknown) {
      console.error('SW registration error', error);
    },
  });

  const applyServiceWorkerUpdate = useCallback(
    async (reloadPage?: boolean) => {
      await updateServiceWorker(reloadPage);
      setRegistrationNeedRefresh(false);
    },
    [setRegistrationNeedRefresh, updateServiceWorker],
  );

  useEffect(
    () => () => {
      if (updateInterval) {
        clearInterval(updateInterval);
        updateInterval = undefined;
      }
    },
    [],
  );

  useEffect(() => {
    setNeedRefresh(needRefresh);
  }, [needRefresh, setNeedRefresh]);

  useEffect(() => {
    setUpdateServiceWorker(applyServiceWorkerUpdate);
    return () => setUpdateServiceWorker(null);
  }, [applyServiceWorkerUpdate, setUpdateServiceWorker]);

  return null;
};
